// TOP LEVEL IMPORTS
import React from 'react';
// ANT
import Card from 'antd/lib/card';
// COMPONENTS
import PaymentForm from './PaymentForm';
// STRIPE
import { Elements } from 'react-stripe-elements';

const styles = {
  paymentFormContainer: {
    width: 430,
    margin: 'auto',
    maxWidth: '100%',
    minHeight: 215,
  },
};

const PaymentFormContainer = ({ invoice, currencySymbol }) => (
  <Card style={styles.paymentFormContainer}>
    <div style={{ minHeight: 135 }}>
      <Elements>
        <PaymentForm invoice={invoice} currencySymbol={currencySymbol} />
      </Elements>
    </div>
  </Card>
);

export default PaymentFormContainer;



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/PaymentFormArea/PaymentFormContainer/index.js